import React from "react";
import { eachDayOfInterval, format, parseISO } from "date-fns";
import { Menu } from "lucide-react";

const TripSidebar = ({
  subTrips = [],
  selectedDay,
  setSelectedDay,
  showMenu,
  setShowMenu,
}) => {
  // 對 subTrips 按日期排序
  const sortedSubTrips = [...subTrips].sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <>
      {/* Floating hamburger icon */}
      <button
        className="fixed top-4 left-4 z-50 bg-white p-2 rounded shadow md:hidden"
        onClick={() => setShowMenu(!showMenu)}
        aria-label="Toggle Menu"
      >
        <Menu className="w-6 h-6 text-gray-700" />
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-md z-40 transform transition-transform duration-300 ease-in-out
          ${showMenu ? "translate-x-0" : "-translate-x-full"} md:relative md:translate-x-0 md:block md:w-40 md:mr-4`}
      >
        <div className="p-4 border-b font-semibold text-lg">Trip Days</div>
        <ul className="p-4 space-y-2 overflow-y-auto max-h-[calc(100vh-80px)]">
        {sortedSubTrips.map((subTrip) => {
          const formattedDate = format(new Date(subTrip.date), "EEE d/M");
          const isSelected = selectedDay === subTrip.date;
            return (
              <li key={subTrip.id}
                onClick={() => setSelectedDay(subTrip.date)}
				className={`cursor-pointer px-4 py-2 rounded hover:bg-gray-100 ${isSelected ? "bg-green-100 font-semibold" : ""}`}
              >
			  <div>{formattedDate}</div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default TripSidebar;